/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { ISoftware, IdValueObj } from '@umati/dashboard-types';
import URLs from '../utilities/URLs';

const SetFullSoftwareImageURLs = (sw: ISoftware, staticBucketReachable: boolean) => {
  sw.iconUrl = URLs.getFullSoftwareImageUrl(sw.iconUrl, staticBucketReachable);
  sw.logoUrl = URLs.getFullSoftwareImageUrl(sw.logoUrl, staticBucketReachable);
  sw.screenshotUrl = URLs.getFullSoftwareImageUrl(sw.screenshotUrl, staticBucketReachable);
  return sw;
};

const arrayToObject = (arr: ISoftware[], key1: keyof ISoftware, staticBucketReachable: boolean) => {
  return Object.assign(
    {},
    ...arr.map((item) => {
      return { [item[key1]!.toString()]: SetFullSoftwareImageURLs(item, staticBucketReachable) };
    }),
  );
};
export class SoftwareHandling {
  static isFavorite(machine: ISoftware, favorites: Set<string>): boolean {
    return favorites.has(machine.SoftwareId);
  }

  static setFavorite(software: IdValueObj<ISoftware>, favorites: string[]) {
    const favSet = new Set<string>(favorites);
    for (const softwareIndex in software) {
      software[softwareIndex].Favorite = SoftwareHandling.isFavorite(software[softwareIndex], favSet);
    }
    return software;
  }

  static deserializeSoftwaresFromBackendRequest(data: ISoftware[], staticBucketReachable: boolean) {
    return arrayToObject(data, 'SoftwareId', staticBucketReachable);
  }
}
